import type { CreateAxiosDefaults } from 'axios'

function getBaseUrl() {
  if (location.origin.indexOf('beta') !== -1) {
    // return 'http://60.73.80.102:9000/api'
    return 'https://api.beta.shaokai-chasing.com/api'
    // return 'https://englishbackend-121945-6-1329511088.sh.run.tcloudbase.com/api'
  }
  if (import.meta.env.MODE === 'development') {
    return 'http://localhost:8080/api'
    // return 'https://apiv2.shaokai-chasing.com/api'
    // return 'http://60.73.80.102:9000/api'
  }
  return 'https://apiv2.shaokai-chasing.com/api'
}
const httpConfig: CreateAxiosDefaults = {
  // baseURL: 'https://api.shaokai-chasing.com/api',
  baseURL: getBaseUrl(),
  // baseURL: 'https://sfctxsmm.englishbackend.bl7wwio2.g2ch5ykx.com',
  timeout: 10000,
}

export default httpConfig
